
export default {
    uploadApk: '/api/CampaignApi/uploadApk',
    getApkInfoForPackage: '/api/CampaignApi/getApkInfoForPackage',
}



// WEBPACK FOOTER //
// ./src/urls/uploadApkUrls.js